module.exports = __webpack_public_path__ + "static/media/logo.73e23c6f.svg";